import {
  fetchFileFromRemote,
  getDuration,
  getReminderTimeArray,
  getRemindTimeFromEventData,
  calculateDate,
  getFrequencyOptions,
  defaultFrequencyOption,
} from '../../common/helpers'

export const mapFormDataToReminderDto = async (formValues) => {
  const image = formValues.image.url
    ? await fetchFileFromRemote(formValues.image.url)
    : formValues.image

  const formData = {
    type: 'Reminder',
    event: false,
    // Reminder details
    buildingId: formValues.building.id,
    name: formValues.name,
    description: formValues.description,
    image: image,
    files: formValues.files,

    // Date/Time
    place: formValues.place,
    date: calculateDate(formValues.timeStart, formValues.building.timezone),
    duration: getDuration(formValues.timeStart, formValues.timeEnd),
    schedulerType:
      formValues.frequency && formValues.frequency !== 'none' ? formValues.frequency : null,

    // Advanced  - communication
    remindAllBeforeHours: formValues.remindAll
      ? getReminderTimeArray(formValues.remindAllValues)
      : [],
    isPrivate: formValues.isPrivate,
  }

  return formData
}

export const mapReminderDtoToFormData = ({ eventData, buildingOptions }) => {
  const formData = {
    building: buildingOptions.find((option) => option.id === eventData.buildingId.id),
    name: eventData.name,
    description: eventData.description,
    image: eventData.image,
    files: eventData.files || [],
    // Date/Time
    place: eventData.place,
    timeStart: eventData.start,
    timeEnd: eventData.end,
    frequency:
      getFrequencyOptions().find((option) => option.value === eventData.schedulerType)?.value ||
      defaultFrequencyOption,
    // Advanced - Communication
    automatedRemindersToggle:
      !!eventData.remindAllBeforeHours.length || !!eventData.remindRsvpBeforeHours.length,
    remindAll: !!eventData.remindAllBeforeHours.length,
    remindAllValues: eventData.remindAllBeforeHours
      ? getRemindTimeFromEventData(eventData.remindAllBeforeHours)
      : [''],
    isPrivate: !!eventData.isPrivate,
  }

  return formData
}
